import React, { ReactNode } from 'react';
import { PopUpButton } from './PopUpButton';
import { Copyright } from './Copyright';
import { Caption } from './Caption';
import { createBlock } from '../../../../lib/bemUtils/bem';

type Figure = {
  isPopUp: boolean;
  hasPopUp?: boolean;
  isPopUpImage?: boolean;
  onClick: () => void;
  padding: boolean;
  copyright?: string;
  caption?: string;
  title?: string;
  alt?: string;
  popUpContent?: ReactNode;
  children?: ReactNode;
};

export function Figure({
  isPopUp,
  hasPopUp,
  isPopUpImage,
  popUpContent,
  onClick,
  padding,
  copyright,
  caption,
  title,
  alt,
  children,
}: Figure) {
  const thisIsAPopUp: boolean | undefined = isPopUp || isPopUpImage;
  const mediaBlock = createBlock('media-information');

  /**
   * The <figure> contains the media (Images, Iframes etc.).
   * It can also contain the figcaption. This consists of copyright, caption and title.
   * The same figure is used in a modal dialog for lightbox view (= pop up).
   */

  return (
    <figure
      className={
        thisIsAPopUp ? 'media-information__figure media-information__figure--pop-up' : 'media-information__figure'
      }
    >
      <div className="media-information__media-container">
        {thisIsAPopUp && popUpContent ? popUpContent : children}
        {hasPopUp && !thisIsAPopUp && <PopUpButton onClick={onClick} />}
      </div>
      {(copyright || caption || title) && (
        <figcaption className={mediaBlock.createElement('figcaption').extender(padding ? 'padding' : null)}>
          {copyright && <Copyright text={copyright} />}
          {caption && <Caption text={caption} hidden={alt ? caption === alt : false} />}
          {title && <p className="media-information__title">{title}</p>}
        </figcaption>
      )}
    </figure>
  );
}
